import * as Blockly from 'blockly';
import { javascriptGenerator, Order } from 'blockly/javascript';
import { GroupchatChannelRegistryService } from 'src/app/shared/services/groupchat-channel-registry.service';
import { BLOCKLY_COLORS } from './blocky-types.types';
import { FieldIcon } from './field-icon';

let _registered = false;
let _registry: GroupchatChannelRegistryService;

function showAddChannelModal(onSave: (name: string) => void): void {
  const name = prompt('Neuen Kanal hinzufügen: Gib einen Kanalnamen ein:');
  if (!name?.trim()) return;
  _registry.addChannel(name.trim());
  onSave(name.trim());
}

class FieldGroupchatChannel extends Blockly.FieldDropdown {
  protected override doClassValidation_(newValue?: string): string | null {
    if (newValue === '__ADD_NEW__') {
      const self = this;
      setTimeout(() => {
        showAddChannelModal((name) => {
          self.setValue(name);
        });
      }, 0);
      return null; // Ungültig → aktuellen Wert behalten
    }
    return super.doClassValidation_(newValue);
  }
}

export function registerGroupchatChannelDropdownBlock(registry: GroupchatChannelRegistryService): void {
  _registry = registry; // Immer aktualisieren (Projektwechsel)
  if (_registered) return;
  _registered = true;

  Blockly.Blocks['GROUPCHAT_CHANNEL_DROPDOWN'] = {
    init(this: Blockly.Block) {
      const field = new FieldGroupchatChannel(() => {
        const opts = _registry.getDropdownOptions();
        return [...opts, ['+ Neuer Kanal...', '__ADD_NEW__']] as [string, string][];
      });
      this.appendDummyInput()
        .appendField(new FieldIcon('ri-chat-1-line'))
        .appendField(' Kanal:')
        .appendField(field as unknown as Blockly.Field, 'CHANNEL');
      this.setOutput(true, 'String');
      this.setColour(BLOCKLY_COLORS.CAT_DATEN_INHALTE);
      this.setTooltip('Wähle einen Kanal aus oder erstelle einen neuen.\n\n🆔 GROUPCHAT_CHANNEL_DROPDOWN');
    },
  };

  javascriptGenerator.forBlock['GROUPCHAT_CHANNEL_DROPDOWN'] = (block) => {
    const channel = (block.getFieldValue('CHANNEL') ?? '').replace(/"/g, '\\"');
    return [`"${channel}"`, Order.ATOMIC];
  };
}
